module.exports = __webpack_public_path__ + "img/person_icon.e273aeca.svg";